import { proxy } from 'core/classes/helpers/UrlHelper'

export const getSlidePreviewSrc = (type: 'qbr' | 'elt', index: number) => {
  return proxy(`/form/rs/forms/1554/images/slides/${type}-slide-${index + 1}.png`)
}
